import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, patchRequest } from 'utils/http'

export const useGetWaitlists = (page = 1, perPage = 25, eventId = '', status = '', search = '') => {
  return useQuery({
    queryKey: ['admin-waitlists', page, perPage, eventId, status, search],
    queryFn: async () => {
      const response = await getRequest('waitlist', {
        params: {
          page,
          per_page: perPage,
          event_id: eventId || undefined,
          status: status || undefined,
          search: search || undefined,
        },
      })
      return response
    },
    keepPreviousData: true,
  })
}

export const useCancelWaitlistEntry = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (id) => {
      return await patchRequest(`waitlist/${id}/cancel`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-waitlists'] })
    },
  })
}
